import Vue from 'vue';

/**
 * UniMicro Authorization
 * Sends client credentials to get UniMicro login URL
 */
const success = function success(response, resolve) {
  resolve(response);
};

const failed = function failed(error, reject) {
  reject(error);
};

export default function authorize(data) {
  return new Promise((resolve, reject) => {
    Vue.$http
      .post('/unimicro/auth-url', data)
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  });
}



// WEBPACK FOOTER //
// ./src/app/services/unimicro/authorize.js